import { ColorV2, Text } from "@adoptaunabuelo/react-components";
import { CSSProperties, useState } from "react";
import styled from "styled-components";
import DonationShield from "../../assets/images/icon/DonationShield";
import ProtectedDonationModal from "./ProtectedDonationModal";

const Container = styled.div``;
const MainButton = styled.div`
	display: flex;
	flex-direction: row;
	padding: 6px 12px 6px 6px;
	background-color: ${ColorV2.surface.primarySoft};
	border: 1px solid ${ColorV2.border.primarySoft};
	border-radius: 8px;
	width: fit-content;
	cursor: pointer;
	gap: 8px;
	align-items: center;
	&:hover {
		background-color: ${ColorV2.surface.primaryLow};
	}
	:hover {
		text-decoration: underline;
	}
`;
const Icon = styled.div`
	height: 24px;
	width: 24px;
`;

const ProtectedDonation = (props: ProtectedDonationProps) => {
	const [showModal, setShowModal] = useState(false);

	return (
		<Container style={props.style}>
			<ProtectedDonationModal
				type={props.type}
				isVisible={showModal}
				onClose={() => setShowModal(false)}
			/>
			<MainButton onClick={() => setShowModal(true)}>
				<Icon>
					<DonationShield size="small" />
				</Icon>
				<Text type="c1" weight="medium">
					Donación segura
				</Text>
			</MainButton>
		</Container>
	);
};
export default ProtectedDonation;
export type ProtectedDonationProps = {
	style?: CSSProperties;
	type: "donation" | "challenge" | "birthday";
};
